import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {DashboardComponent} from './dashboard/dashboard.component';
import {AuthGuard} from '../guards/auth/auth.guard';

const routes: Routes = [
  {
    path: 'my',
    redirectTo: 'my/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'my/dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class MyRoutingModule { }
